import { render, staticRenderFns } from "./EWCityShow.vue?vue&type=template&id=523a7463&"
import script from "./EWCityShow.vue?vue&type=script&lang=js&"
export * from "./EWCityShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports